import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

import routeDefinitions from 'enum/routeDefinitions';


const CONNECTION_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

const TwitterCallbackPage = ({ location: { search } }) => {
  const [isError, setError] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    if (searchParams.get('status') === CONNECTION_STATUS.SUCCESS) {
      window.close();

      return;
    }
    setError(true);
  }, [search]);

  if (isError) {
    return <Redirect to={routeDefinitions.errorPage} />;
  }

  return <div />;
};

TwitterCallbackPage.propTypes = { location: PropTypes.object };

TwitterCallbackPage.defaultProps = { location: {} };

export default TwitterCallbackPage;
